import React from "react";
import http from "services/httpService";
import TpaSetup from "components/Tpa";
import { useNavigate } from "react-router";
import routes from "components/routes";

const TPASetup = () => {
  const userplan_id = localStorage.getItem("eb_current_plan");
  const navigate = useNavigate();
  
  const handleSubmit = async (values) => {
    await updateTpaDetails(values);
  };

  const updateTpaDetails = async (values) => {
    const payload = {
      userplan_id,
      ...values,
    };
    try {
      const { data } = await http.post(
        `/business/update_tpa_details/`,
        payload
      );
      navigate(`/${routes.UNIVERSAL_COVERAGE_DOC}`)
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <section>
      <TpaSetup handleSubmit={handleSubmit} />
    </section>
  );
};

export default TPASetup;
